export const Links = {
	shop: 'https://store.tornado.kg',
	main: 'https://tornado.kg',
	shopName: 'store.tornado.kg',
	mainName: 'tornado.kg'
}

export const ProductTagColors = {
	SALE: 'green', //green
	NEW: 'red', //red
	HOT: 'red', //red
	EXCLUSIVE: 'red', // red
	LIMITED: 'green', // green
	BEST_PRICE: 'green', //green
};

export const ProductTag = {
	SALE: 'SALE', //green
	NEW: 'NEW', //red
	HOT: 'HOT', //red
	EXCLUSIVE: 'EXCLUSIVE', // red
	LIMITED: 'LIMITED', // green
	BEST_PRICE: 'BEST_PRICE', //green
};

export const ProductSidebarTags = [
		ProductTag.SALE,
		ProductTag.NEW,
		ProductTag.HOT,
		ProductTag.EXCLUSIVE,
		ProductTag.LIMITED,
		ProductTag.BEST_PRICE
];

export const ProductsSectionTagsOrders = [
		ProductTag.SALE.toLowerCase(),
		ProductTag.NEW.toLowerCase(),
		ProductTag.HOT.toLowerCase(),
		ProductTag.LIMITED.toLowerCase()
];

export const ProductsSectionTagsThreeOrders = [
	ProductTag.NEW.toLowerCase(),
	ProductTag.HOT.toLowerCase(),
	ProductTag.LIMITED.toLowerCase()
];

export const ProductsPaginatedTake = 12;
export const BlogsPaginatedTake = 12;
export const ProductReviewRepliesPaginatedTake = 8;

export const ProjectType = {
	YOUTUBE: 'YOUTUBE',
	IMAGE: 'IMAGE'
}

export const ProductStatus = {
	IN_STOCK: 'IN_STOCK',
	OUT_OF_STOCK: 'OUT_OF_STOCK',
	ON_ORDER: 'ON_ORDER',
	COMING_SOON: 'COMING_SOON',
};

export const ProductActionStatus = {
	increased: 'increased',
	added: 'added',
	deleted: 'deleted'
};

export const PriceCurrencyRatio = {
	KGS: 1,
	USD: 80,
	default: 1
};

export const CatalogFilterSessionStorage = {
	SORT: 'sortFilter',
	SEARCH: 'searchFilter',
	PRICE_FROM: 'priceFromFilter',
	PRICE_TO: 'priceToFilter',
	CATEGORY: 'categoryFilter',
	SUBCATEGORY: 'subcategoryFilter',
	BRAND: 'brandFilter',
	TAG: 'tagFilter'
};

export const CatalogSortSelectItems = {
	DEFAULT: 'default',
	NEW_ARRIVALS: 'newArrivals',
	PRICE_ASC: 'priceAsc',
	PRICE_DESC: 'priceDesc'
};

export const ClientTypes = {
	ADMIN: 'ADMIN',
	LOYAL: 'LOYAL',
	REGULAR: 'REGULAR',
	WHOLESALER: 'WHOLESALER'
};

export const PaymentTypes = {
	CASH: 'CASH',
	NON_CASH: 'NON_CASH',
};

export const DiscountTypes = {
	PRICE_POLICY: 'PRICE_POLICY',
	COUPON: 'COUPON',
	SALE: 'SALE',
	WHOLESALE: 'WHOLESALE'
};

export const OrderStatuses = {
	PENDING: 'PENDING',
	PREPARING: 'PREPARING',
	READY: 'READY',
	IN_DELIVERY: 'IN_DELIVERY',
	DELIVERED: 'DELIVERED',
	COMPLETED: 'COMPLETED',
	RETURNED: 'RETURNED',
	CANCELED: 'CANCELED'
};

export const OrderStatusIcons = {
	PENDING: {
		icon: 'icon-pending',
		color: 'orange'
	},
	PREPARING: {
		icon: 'icon-packing',
		color: 'teal'
	},
	READY: {
		icon: 'icon-ready-stock',
		color: 'navy'
	},
	IN_DELIVERY: {
		icon: 'icon-just-in-time',
		color: 'teal'
	},
	DELIVERED: {
		icon: 'icon-delivered',
		color: 'navy'
	},
	COMPLETED: {
		icon: 'icon-check-mark',
		color: 'green'
	},
	RETURNED: {
		icon: 'icon-refund',
		color: 'red'
	},
	CANCELED: {
		icon: 'icon-cancel1',
		color: 'red'
	},
};

export const DomPurifyConfig = {
	ADD_TAGS: ['youtube-embed'],
	ADD_ATTR: ['videoid', 'params']
};

export const LOCALE_PATH_NAMES = ['/ru', '/kg', '/en'];
export const ACCESS_TOKEN_COOKIE_NAME = 'accessToken';
export const REFRESH_TOKEN_COOKIE_NAME = 'refreshToken';
export const CURRENT_CURRENCY_COOKIE_NAME = 'currency';
export const BASE_COOKIE_MAX_AGE = 43200000; // 500 days
export const CURRENCY_DEFAULT = 'KGS';
export const ACCOUNT_USER_NAME = 'user';
export const PRIVATE_ROUTE_NAME = '/account';
export const LOGIN_ROUTE_NAME = '/login';
export const LOGOUT_ROUTE_NAME = '/logout';
export const AUTH_ROUTE_NAMES = ['/login', '/register'];
export const CALLBACK_URL_PARAM = 'callbackUrl';
export const UNAUTHORIZED_URL_PARAM = 'unauthorized';

export const CLIENT_BANNED_MESSAGE = 'CLIENT_BANNED';
export const UNAUTHORIZED_MESSAGE = 'Unauthorized';
